// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3yv5r","title":"AfterBackImages_title__2hjUJ","images":"AfterBackImages_images__34wQz"};